<template>
    <div class="background">
        <div style="font-size: 3rem">loading...</div>
    </div>
</template>
<script>
export default {
    name: "jump",
    data() {
        return {
          pid: this.$route.query.pid,
          //url: "",
        }
    },
    methods: {
        jumpUrl() {



          let urla="";
          if(this.pid=="80917") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617538586";}
          if(this.pid=="80042") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617524972";}
          if(this.pid=="76448") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617538590";}
          if(this.pid=="76271") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617538592";}
          if(this.pid=="78006") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617524976";}
          if(this.pid=="77604") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617533001";}
          if(this.pid=="77504") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617538596";}
          if(this.pid=="79398") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617533005";}
          if(this.pid=="76149") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617533006";}
          if(this.pid=="78086") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617530104";}
          if(this.pid=="76272") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617535827";}
          if(this.pid=="76119") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3614396984";}
          if(this.pid=="77325") {	urla = "https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=C734D87e26&channel=09-2279-bokq-9999&ADTAG=09-2279-bokq-9999&referrerCode=3617533011";}

          window.location.href = urla;

        }
    },
  created() {
      this.jumpUrl();
  }
}
</script>


<style lang="scss" scoped>
    .background {
        background-size: 100% 100%;
        height: 98rem;
        padding-top: 28rem;
        text-align: center;
        /*padding: 0;*/
    }

    .inputForm {
        background-color: white;
        width: 85%;
        margin: 0 auto;
        border-radius: 1rem;
        padding: 0.5rem 1rem;
        text-align: center;
    }

</style>
